import { Table } from "antd";
import "antd/dist/reset.css";
import { useEffect } from "react";
import { useBookingList } from "./modules/useBookingList";
import { useColumns } from "./modules/useColumns";
import { useModal } from "./modules/useModal";
import { SearchForm } from "./molecules/searchForm";
import { BookingModal } from "./molecules/bookingModal";

function BookingListTemplate() {
  const {
    fetchBookings,
    fetchRooms,
    fetchRatePlans,
    ratePlans,
    filteredBookings,
    rooms,
    handleFilterSubmit,
    handleResetFilters,
    form,
  } = useBookingList();

  const { showModal, handleCancel, isModalVisible, selectedBooking } =
    useModal();

  useEffect(() => {
    fetchBookings();
    fetchRooms();
    fetchRatePlans();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { columns } = useColumns(showModal);

  return (
    <div className="container">
      <h1>Bookings</h1>
      <SearchForm
        form={form}
        handleFilterSubmit={handleFilterSubmit}
        rooms={rooms}
        ratePlans={ratePlans}
        handleResetFilters={handleResetFilters}
      />

      <Table
        dataSource={filteredBookings}
        columns={columns}
        rowKey="_id"
        pagination={{ pageSize: 10 }}
        scroll={{ x: 1000 }} // Enable horizontal scrolling
      />

      {selectedBooking && (
        <BookingModal
          selectedBooking={selectedBooking}
          isModalVisible={isModalVisible}
          handleCancel={handleCancel}
        />
      )}
    </div>
  );
}

export default BookingListTemplate;
